// Copyright (c) Docugami, Inc. All rights reserved.
import { IconRenderer } from 'components/work_path/IconRenderer';
import { dgIconNames } from 'hooks/dgIcons';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ErrorPageSubText, ErrorPageTitleText } from 'components/common/Fonts';
import { emptyColor } from 'components/shell/presentation/AppStyles';
import { DgColoredButton, useThemedPrimaryButtonProps } from 'components/common/DgCommonStyledComponents';
import { useNavigate } from 'react-router-dom';
import { Telemetry } from 'telemetry/TelemetryManager';
import { TelemetryPageView } from 'telemetry/TelemetryEvents';

const PageContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr 2fr 1fr;
    grid-column-gap: 3%;
    width: 100%;
    height: 100%;
    align-items: center;
`;

const IconContainer = styled.div`
    grid-column-start: 2;
    justify-self: flex-end;
`;

const TextContainer = styled.div`
    display: flex;
    grid-column-start: 3;
    justify-self: flex-start;
    flex-direction: column;
    gap: 10px;
`;

const HomepageButton = styled(DgColoredButton)`
    width: fit-content;
    margin-top: 30px;
`;

export const NotFoundPage = (): JSX.Element => {
    const navigate = useNavigate();
    const navigateToHomepage = () => navigate('/home', { replace: true });
    const buttonProps = useThemedPrimaryButtonProps();

    useEffect(() => {
        Telemetry.trackPageView(TelemetryPageView.NotFound);
    }, []);

    return (
        <PageContainer>
            <IconContainer>
                <IconRenderer
                    source={{
                        name: dgIconNames.DgRobotLarge,
                        height: 485,
                        width: 424,
                        defaultColor: emptyColor
                    }}
                    width={400}
                    height={450} />
            </IconContainer>
            <TextContainer>
                <ErrorPageTitleText>OOPS! PAGE NOT FOUND</ErrorPageTitleText>
                <ErrorPageSubText>Uh Oh! We can't seem to find the page you were looking for.</ErrorPageSubText>
                <HomepageButton controlButtonProps={buttonProps} key='navigate_home' onClick={navigateToHomepage}>Go back home</HomepageButton>
            </TextContainer>
        </PageContainer>
    );
}